import {
    ResponsiveContainer,
    ComposedChart,
    Area,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    Legend,
} from "recharts";

function formatInt(n) {
    return Number(n || 0).toLocaleString("de-DE");
}

function formatDay(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);

    return date.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
    });
}

function buildTooltipLabel(label) {
    return formatDay(label);
}

export default function DailyCasesLineChart({ data = [] }) {
    if (!data.length) {
        return (
            <div className="analysis-diagram-empty">
                No daily trend data available.
            </div>
        );
    }

    const legendLabelMap = {
        openPerDay: "Open per day",
        closedPerDay: "Closed per day",
        totalOpenCases: "Total open cases",
    };

    return (
        <div className="analysis-chart-area">
            <ResponsiveContainer width="100%" height="100%">
                <ComposedChart
                    data={data}
                    margin={{ top: 10, right: 18, left: 4, bottom: 10 }}
                >
                    <defs>
                        <linearGradient id="openAreaFill" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#7C4DFF" stopOpacity={0.38} />
                            <stop offset="95%" stopColor="#7C4DFF" stopOpacity={0.03} />
                        </linearGradient>

                        <linearGradient id="closedAreaFill" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#52EA91" stopOpacity={0.32} />
                            <stop offset="95%" stopColor="#52EA91" stopOpacity={0.03} />
                        </linearGradient>
                    </defs>

                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke="rgba(255,255,255,0.12)"
                        vertical={true}
                    />

                    <XAxis
                        dataKey="day"
                        tickFormatter={formatDay}
                        tick={{ fill: "#8A87A8", fontSize: 12 }}
                        axisLine={{ stroke: "rgba(255,255,255,0.16)" }}
                        tickLine={{ stroke: "rgba(255,255,255,0.16)" }}
                    />

                    <YAxis
                        yAxisId="left"
                        tickFormatter={formatInt}
                        tick={{ fill: "#8A87A8", fontSize: 12 }}
                        axisLine={{ stroke: "rgba(255,255,255,0.16)" }}
                        tickLine={{ stroke: "rgba(255,255,255,0.16)" }}
                        width={52}
                    />

                    <YAxis
                        yAxisId="right"
                        orientation="right"
                        tickFormatter={formatInt}
                        tick={{ fill: "#6CB7FF", fontSize: 12 }}
                        axisLine={{ stroke: "rgba(108,183,255,0.35)" }}
                        tickLine={{ stroke: "rgba(108,183,255,0.35)" }}
                        width={56}
                    />

                    <Tooltip
                        labelFormatter={buildTooltipLabel}
                        formatter={(value, name) => [
                            formatInt(value),
                            legendLabelMap[name] || name,
                        ]}
                        contentStyle={{
                            background: "#151024",
                            border: "1px solid rgba(255,255,255,0.12)",
                            borderRadius: 8,
                            color: "#EDEBFF",
                            boxShadow: "0 10px 24px rgba(0,0,0,0.28)",
                        }}
                        itemStyle={{ color: "#EDEBFF" }}
                        labelStyle={{ color: "#EDEBFF", fontWeight: 700 }}
                    />

                    <Legend
                        verticalAlign="bottom"
                        height={28}
                        formatter={(value) => legendLabelMap[value] || value}
                        wrapperStyle={{ paddingTop: 8 }}
                    />

                    <Area
                        yAxisId="left"
                        type="monotone"
                        dataKey="closedPerDay"
                        name="closedPerDay"
                        stroke="#52EA91"
                        fill="url(#closedAreaFill)"
                        strokeWidth={2.4}
                        dot={{ r: 2.5, strokeWidth: 0, fill: "#52EA91" }}
                        activeDot={{ r: 5 }}
                        isAnimationActive={false}
                    />

                    <Area
                        yAxisId="left"
                        type="monotone"
                        dataKey="openPerDay"
                        name="openPerDay"
                        stroke="#7C4DFF"
                        fill="url(#openAreaFill)"
                        strokeWidth={2.4}
                        dot={{ r: 2.5, strokeWidth: 0, fill: "#7C4DFF" }}
                        activeDot={{ r: 5 }}
                        isAnimationActive={false}
                    />

                    <Line
                        yAxisId="right"
                        type="monotone"
                        dataKey="totalOpenCases"
                        name="totalOpenCases"
                        stroke="#36A2FF"
                        strokeWidth={3}
                        dot={{ r: 3, strokeWidth: 0, fill: "#36A2FF" }}
                        activeDot={{ r: 6 }}
                        isAnimationActive={false}
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </div>
    );
}